import { datadogRum } from "@datadog/browser-rum";
import { Global, LoadingOverlay } from "@mantine/core";
import React, { ReactNode, Suspense } from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";

import { isLocalEnvironment, isProdEnvironment } from "utils/environment";

import App from "./app";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { globalStyles } from "./theme";

if (!isLocalEnvironment()) {
  datadogRum.init({
    applicationId: "59cf04b4-539f-43f3-bbe1-52044f58a072",
    clientToken: "pub830da541b799bdf7f62abdb1801f50e9",
    site: "datadoghq.eu",
    service: "car-owner-app",
    version: process.env.REACT_APP_VERSION,
    env: window?.__RUNTIME_ENV__?.ENVIRONMENT || "local",
    sampleRate: 100,
    /**
     * Premium sessions include replay recordings
     * These now are only recorded in production for only 5% of users
     * */
    premiumSampleRate: isProdEnvironment() ? 5 : 0,
    trackInteractions: true,
  });

  datadogRum.startSessionReplayRecording();
}

type ProvidersProp = {
  children: ReactNode;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const Providers = ({ children }: ProvidersProp) => (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<LoadingOverlay visible loaderProps={{ color: "gray" }} />}>
            <Global styles={globalStyles} />
            {children}
          </Suspense>
        </QueryClientProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if (process.env.REACT_APP_ENABLE_MOCKS === "true") {
  const { worker } = require("./mocks/browser");

  void worker.start();
}

ReactDOM.render(
  <Providers>
    <App />
  </Providers>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
